import axiosInstance from 'common/js/axios-service'

export const createRemindScore = (cookie, userInfo) => {
  return axiosInstance.request({
    url: 'edu/remind_score.json',
    method: 'post',
    data: { cookie, userInfo }
  })
}
